<template>
  <v-dialog
    :value="show"
    persistent
    max-width="340"
    overlay-color="var(--deep-blue)"
    overlay-opacity="0.6"
  >
    <v-card class="log-out-dialog">
      <v-card-title class="log-out-dialog__header">
        <v-avatar size="44" class="log-out-dialog__avatar">
          <v-icon size="22">{{ icon }}</v-icon>
        </v-avatar>
        <mrx-translation
          token="app.dialog.log_out.title"
          :css-classes="['log-out-dialog__title']"
        ></mrx-translation>
      </v-card-title>

      <v-card-text class="log-out-dialog__content">
        <div v-if="hasRecords" id="log-out-records" class="log-out-dialog__records">
          <mrx-translation
            token="app.device.list.records_in_queue.title"
            :css-classes="['log-out-dialog__records-label']"
          ></mrx-translation>
          <span class="log-out-dialog__records-count">{{ records }}</span>
        </div>
        <mrx-translation
          v-if="hasRecords"
          token="app.dialog.log_out.records_kept_message"
          :css-classes="['log-out-dialog__message']"
        ></mrx-translation>
        <mrx-translation
          token="app.dialog.log_out.settings_message"
          :css-classes="['log-out-dialog__message']"
        ></mrx-translation>
      </v-card-text>

      <v-card-actions class="log-out-dialog__actions">
        <v-btn
          id="cancel-log-out"
          class="log-out-dialog__primary"
          block
          depressed
          @click="$emit('cancel')"
        >
          <mrx-translation token="app.dialog.button.cancel"></mrx-translation>
        </v-btn>
        <v-btn
          id="confirm-log-out"
          class="log-out-dialog__secondary"
          block
          outlined
          depressed
          :disabled="!online"
          @click="$emit('confirm')"
        >
          <mrx-translation token="app.nav.menu.account.logout.title"></mrx-translation>
        </v-btn>
        <div v-if="!online" id="log-out-offline-hint" class="log-out-dialog__offline-hint">
          <v-icon size="14" color="#7d9296">{{ icons.mdiWifiOff }}</v-icon>
          <mrx-translation token="app.nav.menu.account.logout.offline_hint"></mrx-translation>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import icons from '@/mixins/icons'
  import { useConnectionStatus } from '@/composables/useConnectionStatus'
  import './styles/log-out-dialog.css'

  export default {
    name: 'LogOutDialog',
    mixins: [icons],
    props: {
      show: { type: Boolean, default: false },
      records: { type: Number, default: 0 },
    },
    setup() {
      const { online } = useConnectionStatus();
      return { online };
    },
    computed: {
      hasRecords() {
        return this.records > 0
      },
      icon() {
        return this.hasRecords ? this.icons.mdiCloudUpload : this.icons.mdiLogout
      },
    },
  }
</script>
